import React, {useCallback, useRef, useState} from 'react';
import {Table, Select, Button, Card, DatePicker, message, Form, Row, Col, InputNumber, Space} from 'antd';
import {DownloadOutlined, FilePdfOutlined, FileTextOutlined, SearchOutlined} from "@ant-design/icons";
import SelectVehicle from './SelectVehicle';
import jsPDF from "jspdf";
import {useNewFmsLogReportMutation} from "../../../slices/rootApiSlices/reportApiSlice";
import {useSelector} from "react-redux";
import 'jspdf-autotable';
import {exportToExcel} from "../../../components/exportToExcel";
import moment from "moment";

const {Option} = Select;

const CanBusSummary = () => {

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 50,
        total: 0,
    });

    const {RangePicker} = DatePicker;
    const [endDate, setEndDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [infoData, setInfoData] = useState({});
    const [vehicle_id, setVehicleID] = useState('');
    const [selectedOperator, setSelectedOperator] = useState("");

    const searchInput = useRef(null);
    const {user} = useSelector((state) => state.auth);
    const [axisHandle, {isLoading}, error] = useNewFmsLogReportMutation();
    const [selectedColumns, setSelectedColumns] = useState([]);

    function disabledDate(current) {
        const tomorrow = moment().add(1, 'days').startOf('day');
        return current && current >= tomorrow;
    }

    const selectedSearchCol = [
        "currentGear",
        "brakePedalPosition",
        "actualRetarderPercentTorque",
        "fuelRate",
        "wheelBasedSpeed",
        "vehicleSpeed",
        "engineSpeed",
        "createdAt",
        "actualEnginePercentTorque",
        "vm",
        "drv1",
        "drv2",
        "instantaneousFuelEconomy",
        "pbs",
        "acceleratorPedalPosition",
        "pdoors",
        "bellowPressFrontAxleLeft",
        "bellowPressFrontAxleRight",
        "bellowPressRearAxleLeft",
        "bellowPressRearAxleRight",
        "steeringWheelAngle",
        "fuelLevel",
        "engineTotalHoursOfOperation",
        "highResVehicleTotalDistance",
        "engineCoolantTemp",
        "ambientAirTemp",
        "serviceBrakeAirPressureCircuit1",
        "serviceBrakeAirPressureCircuit2",
        "LiquetEngineTotalFuelUsed",
        "AftertreatmentDieselExhaustFluidTank1Level",
        "alt1",
        "alt2",
        "alt3",
        "GaseousTotalFuelUsed",
        "driver1Id",
        "driver2Id",
        "hybridBatteryPackRemainingCharge",
        "vehicle_id",
        "vehicleId",
        "engineDM1",
        "transmissionDM1",
        "absDM1",
        "date",
        "ain",
        "acc",
        "gps"
    ];

    const handleQuery = useCallback(async () => {
        try {
            const res = await axisHandle({
                id: vehicle_id,
                token: user?.token,
                list: selectedColumns,
                page: pagination.current,
                perPage: pagination.pageSize,
                startDate,
                resolution: '8s',
                endDate
            }).unwrap();
            console.log(res.info)
            setInfoData({
                ...res?.info,
                start_date: startDate,
                end_date: endDate,
            });
            setTableData(res.data);
            message.success(res?.message || 'İşlem başarılı..');
        } catch (e) {
            message.error(e?.data?.messageTR || 'Bir hata oluştu.Lütfen bir süre sonra tekrar deneyiniz.');
        }
    }, [axisHandle, endDate, pagination.current, pagination.pageSize, selectedColumns, startDate, user?.token, vehicle_id]);

    const handleReset = (clearFilters) => {
        clearFilters();
        setSelectedOperator('');
        setPagination({...pagination, current: 1});
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
            <div style={{padding: 8}}>
                <div style={{marginBottom: 8, display: 'flex'}}>
                    <InputNumber
                        style={{width: '49%', marginRight: 5}}
                        placeholder="Değer"
                        value={selectedKeys[0]}
                        onChange={(value) => setSelectedKeys(value ? [value] : [])}
                    />
                    <Select
                        allowClear
                        style={{width: '49%'}}
                        onChange={value => setSelectedOperator(value)}
                        placeholder="Lütfen seçin"
                        value={selectedOperator}
                    >
                        <Option value=">">Büyüktür</Option>
                        <Option value="<">Küçüktür</Option>
                        <Option value="=">Eşittir</Option>
                    </Select>
                </div>
                <Space>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{width: '100%'}}
                    >
                        Değeri Sil
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setPagination({...pagination, current: 1});
                        }}
                    >
                        Filtrele
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        Kapat
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) => {
            const dataIndexValue = parseFloat(record[dataIndex]);
            const filterValue = parseFloat(value);
            if (isNaN(dataIndexValue) || isNaN(filterValue)) {
                return false;
            }
            switch (selectedOperator) {
                case '>':
                    return dataIndexValue > filterValue;
                case '<':
                    return dataIndexValue < filterValue;
                case '=':
                    return dataIndexValue === filterValue;
                default:
                    return false;
            }
        },
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => text,
    });

    function handleDateChange(date, dateString) {
        const adjustDate = (dateStr) => {
            const date = new Date(dateStr.replace(' ', 'T') + '.000Z');
            date.setHours(date.getHours() - 3);
            return date.toISOString().slice(0, 19).replace('T', ' ');
        };
        const startDate = adjustDate(dateString[0]);
        const endDate = adjustDate(dateString[1]);

        setStartDate(startDate);
        setEndDate(endDate);
    }

    const handleColumnSelect = (value) => {
        setSelectedColumns(value);
    };

    const options = [
        {
            label: 'Olusturulma Tarihi',
            value: 'date',
            dataIndex: 'date',
            key: 'date',
            fixed: 'right',
            width: 100,
            sorter: (a, b) => {
                return new Date(a.date) - new Date(b.date);
            },
            render: (text) => {
                if (!text || text === "-") {
                    return <span>Tarih yok</span>;
                }
                const [day, month, yearAndTime] = text.split('.');
                const [year, time] = yearAndTime.split(' ');
                const isoDateString = `${year}-${month}-${day}T${time}`;
                const date = new Date(isoDateString);
                if (isNaN(date)) {
                    return <span>Geçersiz Tarih</span>;
                }
                date.setHours(date.getHours() + 6);
                const adjustedDate = date.toISOString().slice(0, 19).replace('T', ' ');
                return <span>{adjustedDate}</span>;
            },
        },
        {
            label: 'Retarder Torku (%)',
            value: 'actualRetarderPercentTorque',
            dataIndex: 'actualRetarderPercentTorque',
            key: 'actualRetarderPercentTorque',
            width: '100%',
            fixed: 'left',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Konum',
            value: 'gps',
            dataIndex: 'gps',
            key: 'gps',
            width: '100%',
            fixed: 'left',
            render: (gps) => (
                <span>
                    {gps !== null && gps !== undefined && gps.lat && gps.lon ?
                        `Enlem: ${gps.lat}, Boylam: ${gps.lon}` : '-'}
                </span>
            )
        },
        {
            label: 'Motor Hizi [RPM]',
            value: 'engineSpeed',
            dataIndex: 'engineSpeed',
            key: 'engineSpeed',
            sorter: (a, b) => a.engineSpeed - b.engineSpeed,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Akü Voltajı',
            value: 'ain',
            dataIndex: 'ain.ana5',
            key: 'ain.ana5',
            sorter: (a, b) => a.ain.ana5 - b.ain.ana5,
            render: (text, record) => (
                <span>{(record.ain && record.ain?.ana5) || record.ain?.ana5 === 0 ? record.ain?.ana5.toFixed(2) : '-'}</span>
            ),
        },
        {
            label: 'İvme',
            value: 'acc',
            dataIndex: 'acc',
            key: 'acc',
            render: (text, record) => {
                const axisX = record.acc?.axisX?.mean !== undefined ? record.acc.axisX.mean.toFixed(2) : '-';
                const axisY = record.acc?.axisY?.mean !== undefined ? record.acc.axisY.mean.toFixed(2) : '-';
                const axisZ = record.acc?.axisZ?.mean !== undefined ? record.acc.axisZ.mean.toFixed(2) : '-';
                return (
                    <span>
                        X: {axisX} | Y: {axisY} | Z: {axisZ}
                    </span>
                );
            },
        },
        {
            label: 'Arac Hizi [km/h]',
            value: 'vehicleSpeed',
            dataIndex: 'vehicleSpeed',
            key: 'vehicleSpeed',
            fixed: 'left',
            sorter: (a, b) => a.vehicleSpeed - b.vehicleSpeed,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Anlik Yakit Tüketimi [L/100km]',
            value: 'fuelRate',
            dataIndex: 'fuelRate',
            key: 'fuelRate',
            sorter: (a, b) => a.fuelRate - b.fuelRate,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Tekerlek Bazli Hiz [km/h]',
            value: 'wheelBasedSpeed',
            dataIndex: 'wheelBasedSpeed',
            key: 'wheelBasedSpeed',
            sorter: (a, b) => a.wheelBasedSpeed - b.wheelBasedSpeed,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Gaz Pedali Pozisyonu (%)',
            value: 'acceleratorPedalPosition',
            dataIndex: 'acceleratorPedalPosition',
            key: 'acceleratorPedalPosition',
            sorter: (a, b) => a.acceleratorPedalPosition - b.acceleratorPedalPosition,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Vites',
            value: 'currentGear',
            dataIndex: 'currentGear',
            key: 'currentGear',
            sorter: (a, b) => a.currentGear - b.currentGear,
            render: (text) => (
                <span>{text === -1 ? 'R' : (text !== null && text !== undefined && text !== '' ? text : '-')}</span>
            )
        },
        {
            label: 'Sol Ön Aks (kPa)',
            value: 'bellowPressFrontAxleLeft',
            dataIndex: 'bellowPressFrontAxleLeft',
            key: 'bellowPressFrontAxleLeft',
            sorter: (a, b) => a.bellowPressFrontAxleLeft - b.bellowPressFrontAxleLeft,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Sag Ön Aks (kPa)',
            value: 'bellowPressFrontAxleRight',
            dataIndex: 'bellowPressFrontAxleRight',
            key: 'bellowPressFrontAxleRight',
            sorter: (a, b) => a.bellowPressFrontAxleRight - b.bellowPressFrontAxleRight,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Kapı 1 Durumu',
            value: 'd1_os',
            dataIndex: 'd1_os',
            key: 'd1_os',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'OPENED':
                        return 'Açık';
                    case 'CLOSED':
                        return 'Kapalı';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 1 Hata Durumu',
            value: 'd1_es',
            dataIndex: 'd1_es',
            key: 'd1_es',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'ENABLED':
                        return 'Uygun';
                    case 'DISABLED':
                        return 'Uygun değil';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 2 Durumu',
            value: 'd2_os',
            dataIndex: 'd2_os',
            key: 'd2_os',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'OPENED':
                        return 'Açık';
                    case 'CLOSED':
                        return 'Kapalı';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 2 Hata Durumu',
            value: 'd2_es',
            dataIndex: 'd2_es',
            key: 'd2_es',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'ENABLED':
                        return 'Uygun';
                    case 'DISABLED':
                        return 'Uygun değil';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 3 Hata Durumu',
            value: 'd3_es',
            dataIndex: 'd3_es',
            key: 'd3_es',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'ENABLED':
                        return 'Uygun';
                    case 'DISABLED':
                        return 'Uygun değil';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 3 Durumu',
            value: 'd3_os',
            dataIndex: 'd3_os',
            key: 'd3_os',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'OPENED':
                        return 'Açık';
                    case 'CLOSED':
                        return 'Kapalı';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 4  Durumu',
            value: 'd4_os',
            dataIndex: 'd4_os',
            key: 'd4_os',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'OPENED':
                        return 'Açık';
                    case 'CLOSED':
                        return 'Kapalı';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Kapı 4 Hata Durumu',
            value: 'd4_es',
            dataIndex: 'd4_es',
            key: 'd4_es',
            fixed: 'left',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'ENABLED':
                        return 'Uygun';
                    case 'DISABLED':
                        return 'Uygun değil';
                    default:
                        return 'Bilinmiyor';
                }
            },
        },
        {
            label: 'Sürücü Adı',
            value: 'driverName',
            dataIndex: 'driverName',
            key: 'driverName',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Sürücü Soyadı',
            value: 'driverSurname',
            dataIndex: 'driverSurname',
            key: 'driverSurname',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Sol Arka Aks (kPa)',
            value: 'bellowPressRearAxleLeft',
            dataIndex: 'bellowPressRearAxleLeft',
            key: 'bellowPressRearAxleLeft',
            sorter: (a, b) => a.bellowPressRearAxleLeft - b.bellowPressRearAxleLeft,
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Sag Arka Aks (kPa)',
            value: 'bellowPressRearAxleRight',
            dataIndex: 'bellowPressRearAxleRight',
            key: 'bellowPressRearAxleRight',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Aktüel Motor Torku (%)',
            value: 'actualEnginePercentTorque',
            dataIndex: 'actualEnginePercentTorque',
            key: 'actualEnginePercentTorque',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Araç Hareketi',
            value: 'vm',
            dataIndex: 'vm',
            key: 'vm',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'VM_NOT_DETECTED':
                        return 'Algılanmadı';
                    case 'VM_DETECTED':
                        return 'Algılandı';
                    case 'VM_ERROR':
                        return 'Hata';
                    case 'VM_NOT_AVAILABLE':
                        return 'Mevcut Değil';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Sürücü 1 Çalışma Durumu',
            value: 'drv1',
            dataIndex: 'drv1',
            key: 'drv1',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'REST':
                        return 'Dinleme';
                    case 'DRIVE':
                        return 'Sürüşte';
                    case 'DRV_NOT_AVAILABLE':
                        return 'Uygun değil';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Sürücü 2 Çalışma Durumu',
            value: 'drv2',
            dataIndex: 'drv2',
            key: 'drv2',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'REST':
                        return 'Dinleme';
                    case 'DRIVE':
                        return 'Sürüşte';
                    case 'DRV_NOT_AVAILABLE':
                        return 'Uygun değil';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Mevcut Araç Hızında Mevcut Yakıt Ekonomisi',
            value: 'instantaneousFuelEconomy',
            dataIndex: 'instantaneousFuelEconomy',
            key: 'instantaneousFuelEconomy',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'El Freni Durumu',
            value: 'pbs',
            dataIndex: 'pbs',
            key: 'pbs',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'SET':
                        return 'Ayarlandı';
                    case 'NOT_SET':
                        return 'Ayarlanmadı';
                    case 'PB_NOT_AVAILABLE':
                        return 'PB Uygun değil';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Tüm Kapıların ortak pozisyonu',
            value: 'pdoors',
            dataIndex: 'pdoors',
            key: 'pdoors',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'PD_NOT_AVAILABLE':
                        return 'Uygun değil';
                    case 'AT_LEAST_ONE_DOOR_IS_OPEN':
                        return 'En az bir kapı açık';
                    case 'ALL_DOOR_CLOSED':
                        return 'Tüm kapılar kapalı';
                    case 'CLOSING_LAST_DOOR':
                        return 'Son kapı kapanıyor';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Fren Pedal Pozisyonu (%)',
            value: 'brakePedalPosition',
            dataIndex: 'brakePedalPosition',
            key: 'brakePedalPosition',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Direksiyon Açısı',
            value: 'steeringWheelAngle',
            dataIndex: 'steeringWheelAngle',
            key: 'steeringWheelAngle',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Ortam Hava Sıcaklığı (C°)',
            value: 'ambientAirTemp',
            dataIndex: 'ambientAirTemp',
            key: 'ambientAirTemp',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: '1. Alternatör Şarj Durumu',
            value: 'alt1',
            dataIndex: 'alt1',
            key: 'alt1',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'NOT_CHARGING':
                        return 'Şarj Olmuyor';
                    case 'CHARGING':
                        return 'Şarj Durumunda';
                    default:
                        return text;
                }
            },
        },
        {
            label: '2. Alternatör Şarj Durumu',
            value: 'alt2',
            dataIndex: 'alt2',
            key: 'alt2',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'NOT_CHARGING':
                        return 'Şarj Olmuyor';
                    case 'CHARGING':
                        return 'Şarj Durumunda';
                    default:
                        return text;
                }
            },
        },
        {
            label: '3. Alternatör Şarj Durumu',
            value: 'alt3',
            dataIndex: 'alt3',
            key: 'alt3',
            render: (text) => {
                if (!text) {
                    return '-';
                }
                switch (text) {
                    case 'NOT_CHARGING':
                        return 'Şarj Olmuyor';
                    case 'CHARGING':
                        return 'Şarj Durumunda';
                    default:
                        return text;
                }
            },
        },
        {
            label: 'Toplam Gazlı Yakıt Tüketimi (kg)',
            value: 'GaseousTotalFuelUsed',
            dataIndex: 'GaseousTotalFuelUsed',
            key: 'GaseousTotalFuelUsed',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Sürücü 1 kimliği',
            value: 'driver1Id',
            dataIndex: 'driver1Id',
            key: 'driver1Id',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Sürücü 2 kimliği',
            value: 'driver2Id',
            dataIndex: 'driver2Id',
            key: 'driver2Id',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Hibrit Pil Paketinin Kalan Şarj Yüzdesi',
            value: 'hybridBatteryPackRemainingCharge',
            dataIndex: 'hybridBatteryPackRemainingCharge',
            key: 'hybridBatteryPackRemainingCharge',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Yakit Seviyesi (%)',
            value: 'fuelLevel',
            dataIndex: 'fuelLevel',
            key: 'fuelLevel',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Motor Toplam Çalisma Saati',
            value: 'engineTotalHoursOfOperation',
            dataIndex: 'engineTotalHoursOfOperation',
            key: 'engineTotalHoursOfOperation',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Arac Toplam Mesafesi [km]',
            value: 'highResVehicleTotalDistance',
            dataIndex: 'highResVehicleTotalDistance',
            key: 'highResVehicleTotalDistance',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Motor Sogutma Sistemi Sivisi Sicakligi (C°)',
            value: 'engineCoolantTemp',
            dataIndex: 'engineCoolantTemp',
            key: 'engineCoolantTemp',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Servis Freni Hava Basinci Devresi 1 (kPa)',
            value: 'serviceBrakeAirPressureCircuit1',
            dataIndex: 'serviceBrakeAirPressureCircuit1',
            key: 'serviceBrakeAirPressureCircuit1',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Servis Freni Hava Basinci Devresi 2 (kPa)',
            value: 'serviceBrakeAirPressureCircuit2',
            dataIndex: 'serviceBrakeAirPressureCircuit2',
            key: 'serviceBrakeAirPressureCircuit2',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Sivi Motor Toplam Yakit Kullanimi [L]',
            value: 'LiquetEngineTotalFuelUsed',
            dataIndex: 'LiquetEngineTotalFuelUsed',
            key: 'LiquetEngineTotalFuelUsed',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Adblue Seviyesi (%)',
            value: 'AftertreatmentDieselExhaustFluidTank1Level',
            dataIndex: 'AftertreatmentDieselExhaustFluidTank1Level',
            key: 'AftertreatmentDieselExhaustFluidTank1Level',
            render: (text) => (
                <span>{text !== null && text !== undefined && text !== '' ? text : '-'}</span>
            )
        },
        {
            label: 'Araç Durumu',
            value: 'mcuid',
            dataIndex: 'mcuid.uidw1',
            key: 'mcuid.uidw1',
            render: (text, record) => {
                let uidw1 = record.mcuid?.uidw1;
                let pbs = record.pbs;
                let durum;

                if (uidw1 === "11") {
                    durum = pbs === 'SET' ? 'Rölanti' : 'Seyir Halinde';
                } else if (uidw1 === "01") {
                    durum = 'Durma';
                } else if (uidw1 === "00" || uidw1 === "10") {
                    durum = 'Park';
                } else {
                    durum = ' ';
                }
                return <span>{durum}</span>;
            },
        }
    ];

    const columns = options
        .filter((option) => selectedColumns.includes(option.value))
        .map((option) => ({
            title: option.label,
            dataIndex: option.dataIndex,
            key: option.key,
            sorter: option.sorter ? option.sorter : '',
            ...(selectedSearchCol.includes(option.value) && {...getColumnSearchProps(option.dataIndex)}),
            render: option.render ? option.render : (text) => text,
        }));


    const onPageChange = (page, pageSize) => {
        setPagination({current: page, pageSize: pageSize});
    };

    const generatePDF = () => {
        let pageSize = 'a3';
        let orientation = 'portrait';

        if (selectedColumns.length > 60) {
            pageSize = 'a0';
            orientation = 'landscape';
        } else if (selectedColumns.length > 40) {
            pageSize = 'a1';
            orientation = 'landscape';
        } else if (selectedColumns.length > 20) {
            pageSize = 'a1';
            orientation = 'landscape';
        } else if (selectedColumns.length > 3) {
            pageSize = 'a3';
            orientation = 'landscape';
        }

        const doc = new jsPDF({
            format: pageSize,
            orientation: orientation,
        });

        // En üstteki bilgileri ekleme
        const kapıNumarası = infoData?.operationNumber ? infoData?.operationNumber : '-'
        const araçPlakası = infoData?.plateNumber ? infoData?.plateNumber : '-'
        const raporTarihAralıkları = startDate && endDate
            ? `${moment(startDate).add(3, 'hours').format('DD/MM/YYYY HH:mm:ss')} - ${moment(endDate).add(3, 'hours').format('DD/MM/YYYY HH:mm:ss')}`
            : '-';
        const sürücüAdıSoyadı = infoData?.driverName ? `${infoData?.plateNumber + ' ' + infoData.driverSurname}` : 'Tanimlanmadi'
        const raporOluşturulmaTarihi = moment().format('DD.MM.YYYY HH:mm');
        const raporuOluşturan = user ? user?.name : '-'

        doc.setFontSize(12);

        doc.text(`Kapi Numarasi: ${kapıNumarası}`, 15, 10);
        doc.text(`Rapor Tarih Araliklari: ${raporTarihAralıkları}`, 120, 10);

        doc.text(`Arac Plakasi: ${araçPlakası}`, 15, 20);
        doc.text(`Surucu Adi / Soyadi: ${sürücüAdıSoyadı}`, 120, 20);

        doc.text(`Rapor Olusturulma Tarihi: ${raporOluşturulmaTarihi}`, 15, 30);
        doc.text(`Raporu Olusturan: ${raporuOluşturan}`, 120, 30);

        // Tablo verileri
        const tableDataForPDF = tableData?.map((item) => {
            return selectedColumns.map((column) => {
                if (column === 'date') {
                    const text = item[column];
                    if (!text || text === "-") {
                        return "Tarih yok";
                    }
                    const [day, month, yearAndTime] = text.split('.');
                    const [year, time] = yearAndTime.split(' ');
                    const isoDateString = `${year}-${month}-${day}T${time}`;
                    const date = new Date(isoDateString);
                    if (isNaN(date)) {
                        return "Geçersiz Tarih";
                    }
                    date.setHours(date.getHours() + 6);
                    return date.toISOString().slice(0, 19).replace('T', ' ');
                }

                const value = item[column];
                if (value === null || value === undefined || isNaN(value)) {
                    return "0";
                }
                return parseFloat(value).toFixed();
            });
        });

        const columnsForPDF = selectedColumns.map((column) => {
            const option = options.find((option) => option.value === column);
            return option ? option.label : '';
        });

        doc.autoTable({
            head: [columnsForPDF],
            body: tableDataForPDF,
            startY: 40,
        });

        doc.save('Can_Bus_Ozet_Raporu.pdf');
    };

    const handleExportExcel = () => {

        const selectedOptions = options.filter(option => selectedColumns.includes(option.value));

        const exportData = tableData?.map((row) => {
            const formattedRow = {};
            selectedOptions.forEach((option) => {
                const {dataIndex, render, label} = option;
                const value = row[dataIndex];
                if (render) {
                    const renderedValue = render(value, row);
                    formattedRow[label] = renderedValue?.props?.children || renderedValue;
                } else {
                    formattedRow[label] = value;
                }
            });

            return formattedRow;
        });
        exportToExcel(exportData, selectedOptions, infoData, 'Can_Bus_Ozet_Raporu', user?.name);
    };

    return (
        <Row justify="center">
            <Col xs={24} sm={24} md={24} lg={24} xl={16} xxl={12}>
                <Card title="Canbus Özet Raporu" type="inner" size="small" style={{marginBottom: 10}}>
                    <Form>
                        <SelectVehicle name="vehicleID" onChange={(e) => setVehicleID(e)}/>
                        <Form.Item name="byDate" label="Tarih Aralığı">
                            <RangePicker
                                showTime
                                disabledDate={disabledDate}
                                disabled={isLoading}
                                placeholder={['Başlangıç Tarihi', 'Bitiş Tarihi']}
                                style={{margin: 'auto', marginRight: 3, width: '100%'}}
                                onChange={handleDateChange}
                            />
                        </Form.Item>
                        <Form.Item required={true} name="fmsList" label="Canbus Veri Türü">
                            <Select
                                mode="multiple"
                                style={{width: '100%'}}
                                placeholder="Sütunları Seçin"
                                onChange={handleColumnSelect}
                                value={selectedColumns}
                                disabled={isLoading}
                                defaultValue={{
                                    value: 'date',
                                    label: 'Oluşturulma Tarih / Saat',
                                }}
                            >
                                {options.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Form>
                    <Button
                        type="primary"
                        icon={<DownloadOutlined/>}
                        onClick={handleQuery}
                        style={{marginTop: '16px'}}
                        loading={isLoading}
                        disabled={!vehicle_id || !startDate || !endDate || selectedColumns.length < 1}
                    >
                        Rapor Oluştur
                    </Button>
                </Card>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={20} xxl={24}>
                <Card
                    type="inner"
                    title="Sonuçlar"
                    size="small"
                    extra={
                        <>
                            <Button
                                style={{marginRight: 5}}
                                size="small"
                                disabled={!tableData?.length || isLoading}
                                type="primary"
                                icon={<FileTextOutlined/>}
                                onClick={handleExportExcel}
                            >Excel
                            </Button>
                            <Button
                                size="small"
                                disabled={true}
                                type="primary"
                                icon={<FilePdfOutlined/>}
                                onClick={generatePDF}
                            >Pdf</Button>
                        </>
                    }
                >
                    {columns.length > 0 && (
                        <Table
                            rowKey="id"
                            loading={isLoading}
                            bordered={true}
                            size="small"
                            scroll={{
                                x: 1000,
                            }}
                            columns={columns}
                            dataSource={tableData}
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                onChange: onPageChange,
                            }}
                            error={error}
                        />
                    )}
                </Card>
            </Col>
        </Row>
    );
};

export default CanBusSummary;
